import { render, staticRenderFns } from "./CardTypeIndex.vue?vue&type=template&id=05baec56&scoped=true"
import script from "./CardTypeIndex.vue?vue&type=script&lang=js"
export * from "./CardTypeIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05baec56",
  null
  
)

export default component.exports